__turbopack_context__.v({
  "accessibleDescription": "wrapped-stories-module-scss-module__7DE7uW__accessibleDescription",
  "badge": "wrapped-stories-module-scss-module__7DE7uW__badge",
  "barFill": "wrapped-stories-module-scss-module__7DE7uW__barFill",
  "barLabel": "wrapped-stories-module-scss-module__7DE7uW__barLabel",
  "barLine": "wrapped-stories-module-scss-module__7DE7uW__barLine",
  "barRow": "wrapped-stories-module-scss-module__7DE7uW__barRow",
  "barValue": "wrapped-stories-module-scss-module__7DE7uW__barValue",
  "bars": "wrapped-stories-module-scss-module__7DE7uW__bars",
  "card": "wrapped-stories-module-scss-module__7DE7uW__card",
  "controls": "wrapped-stories-module-scss-module__7DE7uW__controls",
  "imageProgress": "wrapped-stories-module-scss-module__7DE7uW__imageProgress",
  "meta": "wrapped-stories-module-scss-module__7DE7uW__meta",
  "mood": "wrapped-stories-module-scss-module__7DE7uW__mood",
  "moodLabel": "wrapped-stories-module-scss-module__7DE7uW__moodLabel",
  "moodLine": "wrapped-stories-module-scss-module__7DE7uW__moodLine",
  "moodPoint": "wrapped-stories-module-scss-module__7DE7uW__moodPoint",
  "pagerDot": "wrapped-stories-module-scss-module__7DE7uW__pagerDot",
  "ready": "wrapped-stories-module-scss-module__7DE7uW__ready",
  "rules": "wrapped-stories-module-scss-module__7DE7uW__rules",
  "segments": "wrapped-stories-module-scss-module__7DE7uW__segments",
  "sessionAction": "wrapped-stories-module-scss-module__7DE7uW__sessionAction",
  "sessionLabel": "wrapped-stories-module-scss-module__7DE7uW__sessionLabel",
  "story": "wrapped-stories-module-scss-module__7DE7uW__story",
  "story-breathe": "wrapped-stories-module-scss-module__7DE7uW__story-breathe",
  "story-check": "wrapped-stories-module-scss-module__7DE7uW__story-check",
  "story-fade": "wrapped-stories-module-scss-module__7DE7uW__story-fade",
  "story-grow": "wrapped-stories-module-scss-module__7DE7uW__story-grow",
  "story-nudge": "wrapped-stories-module-scss-module__7DE7uW__story-nudge",
  "story-paint": "wrapped-stories-module-scss-module__7DE7uW__story-paint",
  "story-pop": "wrapped-stories-module-scss-module__7DE7uW__story-pop",
  "story-rise": "wrapped-stories-module-scss-module__7DE7uW__story-rise",
  "story-slide": "wrapped-stories-module-scss-module__7DE7uW__story-slide",
  "story-sun": "wrapped-stories-module-scss-module__7DE7uW__story-sun",
  "story-value": "wrapped-stories-module-scss-module__7DE7uW__story-value",
  "storyContent": "wrapped-stories-module-scss-module__7DE7uW__storyContent",
  "storyDots": "wrapped-stories-module-scss-module__7DE7uW__storyDots",
  "storyFooter": "wrapped-stories-module-scss-module__7DE7uW__storyFooter",
  "storyTitle": "wrapped-stories-module-scss-module__7DE7uW__storyTitle",
  "subtitle": "wrapped-stories-module-scss-module__7DE7uW__subtitle",
  "track": "wrapped-stories-module-scss-module__7DE7uW__track",
  "value": "wrapped-stories-module-scss-module__7DE7uW__value",
});
